/**
 * «Hoy en el equipo», el bloque de Inicio: quién no está hoy, quién trabaja
 * desde casa y quién cumple años esta semana. Es lo que devuelve
 * controller/equipo/hoy.do; cada lista viene ya filtrada por el backend.
 */
export class EquipoHoy {
  /** yyyy-MM-dd del servidor. */
  fecha: string | null = null;
  /** detalle = yyyy-MM-dd del último día de vacaciones. */
  vacaciones: PersonaHoy[] = [];
  /** detalle = "FALTA" | "SALIDA hh:mm" | "ENTRADA hh:mm". */
  permisos: PersonaHoy[] = [];
  /** detalle = "Todo el dia" | "Manana" | "Tarde". */
  homeOffice: PersonaHoy[] = [];
  /** detalle = dd/MM del cumpleaños; enDias = 0 es hoy. Ordenados por cercanía. */
  cumpleanos: PersonaHoy[] = [];
}

export class PersonaHoy {
  nombre: string;
  detalle: string | null = null;
  enDias: number | null = null;
}
